import Axios from "../config/Axios";
import Prefix from "../config/ApiPrefix";
import {
  REGISTER_USER_VALIDATION,
  GET_USER_CURRENT_LOCATION_FAIL,
  GET_USER_CURRENT_LOCATION_REQUEST,
  VERFIY_USER_REQUEST,
  VERFIY_USER_SUCCESS,
  VERFIY_USER_FAIL,
  GET_USER_CURRENT_LOCATION_SUCCESS,
  POST_EVENT_REGISTRATION,
  POST_EVENT_REGISTRATION_SUCCESS,
  POST_EVENT_REGISTRATION_FAIL,
  GET_CALL_FAIL,
  GET_CALL_REQUEST,
  GET_CALL_SUCCESS,
  GET_IMAGINE_TESTIMONIALS_REQUEST,
  GET_IMAGINE_TESTIMONIALS_FAIL,
  GET_EVENTS,
  GET_EVENTS_SUCCESS,
  GET_EVENTS_FAILS,
  GET_IMAGINE_TESTIMONIALS_SUCCESS,
  GET_CITIES_FAIL,
  GET_IMG_PACKAGES_FAIL,
  GET_IMG_PACKAGES_SUCCESS,
  GET_IMG_PACKAGES_REQUEST,
  GET_CITIES_REQUEST,
  GET_CITIES_SUCCESS,
  GET_PACKAGES_FAIL,
  GET_PACKAGES_REQUEST,
  GET_STATE_REQUEST,
  GET_STATE_SUCCESS,
  GET_STATE_ERROR,
  GET_PACKAGES_SUCCESS,
  GET_PACKAGE_DETAILS_FAIL,
  GET_PACKAGE_DETAILS_REQUEST,
  GET_PACKAGE_DETAILS_SUCCESS,
  GET_SERVICES_FAIL,
  GET_SERVICES_REQUEST,
  GET_SERVICES_SUCCESS,
  GET_SERVICE_DETAILS_FAIL,
  GET_SERVICE_DETAILS_REQUEST,
  GET_SERVICE_DETAILS_SUCCESS,
  LOGIN_OTP_ERROR,
  LOGIN_OTP_SUCCESS,
  LOGIN_OTP_REQUEST,
  OTP_VERIFICATION_REQUEST,
  OTP_VERIFICATION_SUCCESS,
  OTP_VERIFICATION_ERROR,
  REGISTER_USER_FAIL,
  REGISTER_USER_SUCCESS,
  REGISTER_USER_REQUEST,
  GET_CITY_FAIL,
  GET_CITY_REQUEST,
  GET_CITY_SUCCESS,
  SET_CITY_FAIL,
  SET_CITY_SUCCESS,
  SET_SEARCH_SUCCESS,
  SET_SEARCH_FAIL,
  GET_CUSTOMER_BOOKING_FAIL,
  GET_CUSTOMER_BOOKING_REQUEST,
  GET_CUSTOMER_BOOKING_SUCCESS,
  GET_REPORT_REQUEST,
  GET_REPORT_SUCCESS,
  GET_REPORT_FAIL,
  GET_CUSTOMER_DASHBOARD_REQUEST,
  GET_CUSTOMER_DASHBOARD_SUCCESS,
  GET_CUSTOMER_DASHBOARD_FAIL,
  GET_BLOG_SUCCESS,
  GET_TESTIMONIALS_REQUEST,
  GET_TESTIMONIALS_SUCCESS,
  GET_TESTIMONIALS_FAIL,
  GET_BLOGS_REQUEST,
  GET_BLOGS_SUCCESS,
  GET_BLOGS_FAIL,
  EDIT_PROFILE_REQUEST,
  EDIT_PROFILE_SUCCESS,
  EDIT_PROFILE_ERROR,
  GET_ALL_PACKAGES_REQUEST,
  GET_ALL_PACKAGES_SUCCESS,
  GET_ALL_PACKAGES_FAIL,
  GET_DIRECT_REPORT_REQUEST,
  GET_DIRECT_REPORT_SUCCESS,
  GET_DIRECT_REPORT_FAIL,
  SEND_PROFILE_DATA,
  SEND_PROFILE_DATA_SUCCESS,
  SEND_PROFILE_DATA_ERROR,
  GET_JOB_REQUEST,
  GET_JOB_REQUEST_SUCCESS,
  GET_JOB_REQUEST_FAIL,
  SMS_VERIFICATION_CANCEL,
  SMS_VERIFICATION_CANCEL_SUCCESS,
  SMS_VERIFICATION_CANCEL_ERROR,
  SMS_VERIFICATION_CONFIRM,
  SMS_VERIFICATION_CONFIRM_SUCCESS,
  SMS_VERIFICATION_CONFIRM_ERROR,
  VIEW_BOOKING,
  VIEW_BOOKING_SUCCESS,
  VIEW_BOOKING_ERROR,
  UPLOAD_PRESCRIPTION,
  UPLOAD_PRESCRIPTION_SUCCESS,
  UPLOAD_PRESCRIPTION_ERROR,
  GET_PACKAGES_LIST_SUCCESS,
  GET_PACKAGE_CATEGORY_REQUEST,
  GET_PACKAGE_CATEGORY_SUCCESS,
  GET_PACKAGE_CATEGORY_FAIL,
  POST_FEANCHISE_FORM_REQUEST,
  POST_FEANCHISE_FORM_SUCCESS,
  POST_FEANCHISE_FORM_ERROR,
  NEWS_LETTER_REQUEST,
  NEWS_LETTER_SUCCESS,
  NEWS_LETTER_ERRROR,
  UNSUBSCRIEBE_REQUEST,
  UNSUBSCRIEBE_REQUEST_SUCCESS,
  UNSUBSCRIEBE_REQUEST_ERROR,
  GET_CENTER_REQUEST,
  GET_CENTER_SUCCESS,
  GET_CENTER_FAIL,
  GET_CENTER_COLLECTION_REQUEST,
  GET_CENTER_COLLECTION_SUCCESS,
  GET_CENTER_COLLECTION_FAIL,
  PAGINATION_REQUEST,
  PAGINATION_REQUEST_SUCCESS,
  PAGINATION_COLLECTION_FAIL,
  LAB_PAGINATION_COLLECTION_FAIL,
  LAB_PAGINATION_REQUEST_SUCCESS,
  LAB_PAGINATION_REQUEST,
  CAREER_PAGINATION_COLLECTION_FAIL,
  CAREER_PAGINATION_REQUEST_SUCCESS,
  CAREER_PAGINATION_REQUEST,
  GET_FAMILY_FRIENDS_DATA_REQUEST,
  GET_FAMILY_FRIENDS_DATA_REQUEST_SUCCESS,
  GET_FAMILY_FRIENDS_DATA_FAIL,
  POST_FAMILY_FRIENDS_DATA_REQUEST,
  POST_FAMILY_FRIENDS_DATA_REQUEST_SUCCESS,
  POST_FAMILY_FRIENDS_DATA_FAIL,
  GET_ALL_ADDRESS_REQUEST,
  GET_ALL_ADDRESS_REQUEST_SUCCESS,
  GET_ALL_ADDRESS_REQUEST_FAIL,
  CREATE_ADDRESS_REQUEST,
  CREATE_ADDRESS_REQUEST_SUCCESS,
  CREATE_ADDRESS_REQUEST_FAIL,
  EDIT_ADDRESS_REQUEST,
  EDIT_ADDRESS_REQUEST_SUCCESS,
  EDIT_ADDRESS_REQUEST_FAIL,
  GET_REPORT_REQUEST_USER,
  GET_REPORT_SUCCESS_USER,
  GET_REPORT_ERROR_USER,
  GET_CART_REQUEST,
  GET_CART_SUCCESS,
  GET_CART_ERROR,
  GET_CARRERDATA,
  GET_CARRERDATA_SUCCESS,
  GET_CARRERDATA_FAIL,
  DELETE_CART_ERROR,
  DELETE_CART_SUCCESS,
  DELETE_CART_REQUEST,
  DELETE_MULTI_ITEMS_CART_REQUEST,
  DELETE_MULTI_ITEMS_CART_SUCCESS,
  DELETE_MULTI_ITEMS_CART_ERROR,
  POST_CART_ERROR,
  POST_CART_SUCCESS,
  POST_CART_REQUEST,
  GET_TEST_PARAMETER,
  GET_TEST_PARAMETER_SUCCESS,
  GET_TEST_PARAMETER_FAIL,
  GET_PINCODE_REQUEST,
  GET_PINCODE_SUCCESS,
  GET_PINCODE_ERROR,
  POST_ADDRESS_REQUEST,
  POST_ADDRESS_REQUEST_SUCCESS,
  POST_ADDRESS_FAIL,
  DELETE_ADDREESS_REQUEST,
  DELETE_ADDRESS_SUCCESS,
  DELETE_ADDREESS_FAIL,
  CREATE_BOOKING_REQUEST,
  CREATE_BOOKING_SUCCESS,
  CREATE_BOOKING_ERROR,
  POST_PAYMENT_INFO_FAIL,
  POST_PAYMENT_INFO_SUCCESS,
  POST_PAYMENT_INFO,
  EMPTY_REDUCER,
  EMPTY_CART_REQUEST,
  EMPTY_CART_SUCCESS,
  EMPTY_CART_FAIL,
  UPLOAD_PRESCRIPTION_LP,
  UPLOAD_PRESCRIPTION_SUCCESS_LP,
  UPLOAD_PRESCRIPTION_ERROR_LP,
  EPMTY_CART_OBJECT,
  SELECT_SLOT,
  GET_ALL_IMG_PACKAGES_REQUEST,
  GET_ALL_IMG_PACKAGES_SUCCESS,
  GET_ALL_IMG_PACKAGES_FAIL,
  GET_ADDRESS_IMG_PACKAGES_REQUEST,
  GET_ADDRESS_IMG_PACKAGES_SUCCESS,
  GET_ADDRESS_IMG_PACKAGES_FAIL,
  GET_COUPON_CODE_REQUEST,
  GET_COUPON_CODE_SUCCESS,
  GET_COUPON_CODE_ERROR,
  SET_ADDON_FALSE,
  SET_ADDON_TRUE,
  ADD_FEEDBACK_FAIL,
  ADD_FEEDBACK_SUCCESS,
  ADD_FEEDBACK_REQUEST,
  GET_REDCASH,
  GET_REDCASH_SUCCESS,
  GET_REDCASH_FAIL,
  GET_REDCASH_DETAILS,
  GET_REDCASH_DETAILS_SUCCESS,
  GET_REDCASH_DETAILS_FAIL,
  SET_CENTERADDRESS_SUCCESS,
  SET_CENTERADDRESS_FAIL,
  GET_IMG_TIME_SLOT_REQUEST,
  GET_IMG_TIME_SLOT_SUCCESS,
  GET_IMG_TIME_SLOT_ERROR,
  GET_DETAILS_IMG_PACKAGES_REQUEST,
  GET_DETAILS_IMG_PACKAGES_SUCCESS,
  GET_DETAILS_IMG_PACKAGES_FAIL,
  GET_MAP_MY_INDIA_ACCESS_TOKEN,
  GET_MAP_MY_INDIA_ACCESS_TOKEN_SUCCESS,
  GET_MAP_MY_INDIA_ACCESS_TOKEN_FAIL,
  GET_CITY_MAIN_REQUEST,
  GET_CITY_MAIN_SUCCESS,
  GET_CITY_MAIN_FAIL,
  SET_ISLOGOUT_FAIL,
  SET_ISLOGOUT_SUCCESS,
  GET_PRESCRIPTION_DATA_REQUEST,
  GET_PRESCRIPTION_DATA_SUCCESS,
  GET_PRESCRIPTION_DATA_FAIL,
  GET_FAMILY_CART_DATA_REQUEST,
  GET_FAMILY_CART_DATA_SUCCESS,
  GET_FAMILY_CART_DATA_FAIL,
  GET_CARRER_DATA_JOB_POSTING,
  GET_CARRER_DATA_JOB_POSTING_SUCCESS,
  GET_CARRER_DATA_JOB_POSTING_FAIL
} from "./Constants";


export const getPackageList = (page = 1, url = "", city = "") => async (
  dispatch
) => {
  try {
    dispatch({
      type: GET_PACKAGES_REQUEST,
    });
    if (city && city !== "") {
      var { data } = await Axios.get(
        `${Prefix.api}/package/data_web/?page=${page}&city=${city}`
      );
    } else {
      var { data } = await Axios.get(
        `${Prefix.api}/package/data_web/?page=${page}`
      );
    }
    dispatch({
      type: GET_PACKAGES_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: GET_PACKAGES_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const getPackageCategory = () => async (dispatch) => {
  try {
    // dispatch({
    //   type: GET_PACKAGE_CATEGORY_REQUEST,
    // });

    const { data } = await Axios.get(`${Prefix.api}/package/category/`);
    // console.log(data, "action");
    dispatch({
      type: GET_PACKAGE_CATEGORY_SUCCESS,
      payload: data,
    });
  } catch (error) {
    // dispatch({
    //     type: GET_PACKAGE_CATEGORY_FAIL,
    //     payload: error.response && error.response.data.message ? error.response.data.message : error.message
    // })
  }
};

export const getCareerData = () => async (dispatch) => {
  try {
    dispatch({
      type: GET_CARRERDATA,
    });
    const { data } = await Axios.get(`${Prefix.api}/career/job-posting/`);
    dispatch({
      type: GET_CARRERDATA_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: GET_CARRERDATA_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const getJobPostingCareerData = () => async (dispatch) => {
  try {
    dispatch({
      type: GET_CARRER_DATA_JOB_POSTING,
    });
    const { data } = await Axios.get(`${Prefix.api}/core/career/jobprofile/`);
    console.log(data,"here")
    dispatch({
      type: GET_CARRER_DATA_JOB_POSTING_SUCCESS,
      payload: data.results,
    });
  } catch (error) {
    dispatch({
      type: GET_CARRER_DATA_JOB_POSTING_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// export const getPackageCategory =
// async (dispatch) => {
//   try {
//     dispatch({
//       type:  GET_PACKAGE_CATEGORY_REQUEST,
//     });
//     if (city.length > 0) {
//       var { data } = await Axios.get(
//         `${Prefix.api}/package/category/?page=${page}${url}&size=8&city=${city}`
//       );
//     } else {
//       var { data } = await Axios.get(
//         `${Prefix.api}/package/category/?page=${page}${url}`
//       );
//     }
//     dispatch({
//       type: GET_PACKAGE_CATEGORY_SUCCESS,
//       payload: data,
//     });
//   } catch (error) {
//     dispatch({
//       type: GET_PACKAGE_CATEGORY_FAIL,
//       payload:
//         error.response && error.response.data.message
//           ? error.response.data.message
//           : error.message,
//     });
//   }
// };

export const getAllPackageList = (name, city) => async (dispatch) => {
  try {
    dispatch({
      type: GET_ALL_PACKAGES_REQUEST,
    });
    if (name && city) {
      var { data } = await Axios.get(
        `${Prefix.api}/package/data_web/?&search=${name}&size=""&city=${city}`
      );
    } else {
      var { data } = await Axios.get(
        `${Prefix.api}/package/data_web/?&search=${name}`
      );
    }

    dispatch({
      type: GET_ALL_PACKAGES_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: GET_ALL_PACKAGES_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const getAllImagingPackageList = (name = "", city, page, type) => async (
  dispatch
) => {
  try {
    dispatch({
      type: GET_ALL_IMG_PACKAGES_REQUEST,
    });
    if (city && name !== "" && page) {
      var { data } = await Axios.get(
        `${Prefix.api}/package/data_web/imaging/?search=${name}&city=${city}&page=${page}&type=${type ?? ""}`
      );
    } else if (city && page) {
      var { data } = await Axios.get(
        `${Prefix.api}/package/data_web/imaging/?city=${city}&page=${page}&type=${type ?? ""}`
      );
    } else if (city && name !== "") {
      var { data } = await Axios.get(
        `${Prefix.api}/package/data_web/imaging/?search=${name}&city=${city}&type=${type ?? ""}`
      );
    } else if (name !== "") {
      var { data } = await Axios.get(
        `${Prefix.api}/package/data_web/imaging/?search=${name}&type=${type ?? ""}`
      );
    } else if (page && type) {
      var { data } = await Axios.get(
        `${Prefix.api}/package/data_web/imaging/?page=${page}&type=${type}`
      );
    } else if (page) {
      var { data } = await Axios.get(
        `${Prefix.api}/package/data_web/imaging/?page=${page}&type=${type ?? ""}`
      );
    } else if (type) {
      var { data } = await Axios.get(
        `${Prefix.api}/package/data_web/imaging/?type=${type}`
      );
    } else {
      var { data } = await Axios.get(`${Prefix.api}/package/data_web/imaging/`);
    }

    dispatch({
      type: GET_ALL_IMG_PACKAGES_SUCCESS,
      payload: data,
    });

  } catch (error) {
    dispatch({
      type: GET_ALL_IMG_PACKAGES_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const ImagingPackageList = (city) => async (dispatch) => {
  try {
    dispatch({
      type: GET_IMG_PACKAGES_REQUEST,
    });

    if (city) {
      var { data } = await Axios.get(
        `${Prefix.api}/package/data_web/imaging/?city=${city}`
      );
    } else {
      var { data } = await Axios.get(`${Prefix.api}/package/data_web/imaging/`);
    }

    dispatch({
      type: GET_IMG_PACKAGES_SUCCESS,
      payload: data.results,
    });
  } catch (error) {
    dispatch({
      type: GET_IMG_PACKAGES_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const getAddressImagingPackageList = (
  packageName,
  city,
  center
) => async (dispatch) => {
  try {
    dispatch({
      type: GET_ADDRESS_IMG_PACKAGES_REQUEST,
    });

    var { data } = await Axios.get(
      `${Prefix.api
      }/package/v2/data_web/imaging/${packageName}/?city=${city}&center=${center ??
      ""}`
    );

    dispatch({
      type: GET_ADDRESS_IMG_PACKAGES_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: GET_ADDRESS_IMG_PACKAGES_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const getCustomerDashboard = (Token) => async (dispatch) => {
  try {
    dispatch({
      type: GET_CUSTOMER_DASHBOARD_REQUEST,
    });
    const { data } = await Axios.get(`${Prefix.api}/auth/shortprofile/`, {
      headers: {
        Authorization: `Token ${Token && Token}`,
      },
    });

    dispatch({
      type: GET_CUSTOMER_DASHBOARD_SUCCESS,
      payload: data,
    });

    // console.log(test);
    // console.log(Token);
  } catch (error) {
    dispatch({
      type: GET_CUSTOMER_DASHBOARD_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const ExistingCustomerCheck = (Token) => async (dispatch) => {
  try {
    const { data } = await Axios.get(`${Prefix.api}/auth/shortprofile/`, {
      headers: {
        Authorization: `Token ${Token}`,
      },
    });

    const { profile } = data;
    console.log("existing user", profile);

    // if(profile.fullname =="guest"){
    //   pushRoute();
    // }else{
    //   console.log("NEW USER")
    // }

    if (profile.email == null) {
      console.log("GUEST OR NEW USER");
      return false;
    } else {
      console.log("EXISTING USER");
      return true;
    }
  } catch (error) {
    console.log(error);
  }
};
export const getBlogDetails = (slug) => async (dispatch) => {
  try {
    // dispatch({
    //   type: GET_BLOG_REQUEST,
    // });

    const { data } = await Axios.get(`${Prefix.api}/blog/blog/${slug}/`);
    // console.log(data, "action");
    dispatch({
      type: GET_BLOG_SUCCESS,
      payload: data,
    });
  } catch (error) {
    // dispatch({
    //     type: GET_BLOG_FAIL,
    //     payload: error.response && error.response.data.message ? error.response.data.message : error.message
    // })
  }
};

export const directReport = (reportslug) => async (dispatch) => {
  try {
    dispatch({
      type: GET_DIRECT_REPORT_REQUEST,
    });

    const { data } = await Axios.get(
      `${Prefix.api}/booking/direct_report/${reportslug}/`
    );
    // console.log(data, "action");
    dispatch({
      type: GET_DIRECT_REPORT_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: GET_DIRECT_REPORT_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const getPackageDetails = (slug, city) => async (dispatch) => {
  try {
    dispatch({
      type: GET_PACKAGE_DETAILS_REQUEST,
    });
    if (city) {
      var { data } = await Axios.get(
        `${Prefix.api}/package/data_web/${slug}/?city=${city}`
      );
    } else {
      var { data } = await Axios.get(`${Prefix.api}/package/data/${slug}/`);
    }
    dispatch({
      type: GET_PACKAGE_DETAILS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: GET_PACKAGE_DETAILS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const getServiceList = () => async (dispatch) => {
  try {
    dispatch({
      type: GET_SERVICES_REQUEST,
    });
    const { data } = await Axios.get(`${Prefix.api}/service/data/`);
    dispatch({
      type: GET_SERVICES_SUCCESS,
      payload: data,
    });
    console.log(test);
  } catch (error) {
    dispatch({
      type: GET_SERVICES_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const getServiceDetails = (slug) => async (dispatch) => {
  try {
    dispatch({
      type: GET_SERVICE_DETAILS_REQUEST,
    });
    const { data } = await Axios.get(
      `${Prefix.api}/service/data/?slug=${slug}`
    );
    dispatch({
      type: GET_SERVICE_DETAILS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: GET_SERVICE_DETAILS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const getPackParams = (packageId) => async (dispatch) => {
  try {
    dispatch({
      type: GET_TEST_PARAMETER,
    });
    const { data } = await Axios.get(
      `${Prefix.api}/package/pack-parameter/${packageId}/`
    );
    dispatch({
      type: GET_TEST_PARAMETER_SUCCESS,
      payload: data.results,
    });
  } catch (error) {
    dispatch({
      type: GET_TEST_PARAMETER_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};
export const getRedcash = (token) => async (dispatch) => {
  try {
    dispatch({
      type: GET_REDCASH,
    });
    const { data } = await Axios.get(`${Prefix.api}/coupon/redcash/`, {
      headers: {
        Authorization: `Token ${token}`,
      },
    });
    dispatch({
      type: GET_REDCASH_SUCCESS,
      payload: data.results,
    });
  } catch (error) {
    dispatch({
      type: GET_REDCASH_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const getRedcashDetails = (token) => async (dispatch) => {
  try {
    dispatch({
      type: GET_REDCASH_DETAILS,
    });
    const { data } = await Axios.get(`${Prefix.api}/coupon/redcashdetails/`, {
      headers: {
        Authorization: `Token ${token}`,
      },
    });
    dispatch({
      type: GET_REDCASH_DETAILS_SUCCESS,
      payload: data.results,
    });
  } catch (error) {
    dispatch({
      type: GET_REDCASH_DETAILS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const getCall = (body) => async (dispatch) => {
  try {
    dispatch({
      type: GET_CALL_REQUEST,
    });
    const { data } = await Axios.post(
      `${Prefix.api}/lead/generate-lead-by-user/`,
      body
    );
    dispatch({
      type: GET_CALL_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: GET_CALL_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const setAllPackageAddonTrue = () => async (dispatch) => {
  try {
    dispatch({
      type: SET_ADDON_TRUE,
      payload: true,
    });
  } catch (error) {
    console.log(error);
  }
};

export const setAllPackageAddonFalse = () => async (dispatch) => {
  try {
    dispatch({
      type: SET_ADDON_FALSE,
      payload: false,
    });
  } catch (error) {
    console.log(error);
  }
};

export const getCities = (name = "") => async (dispatch) => {
  try {
    dispatch({
      type: GET_CITIES_REQUEST,
    });
    const { data } = await Axios.get(`${Prefix.api}/core/cities/?q=${name}`);
    dispatch({
      type: GET_CITIES_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: GET_CITIES_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const otpLogin = (otpDetails) => async (dispatch) => {
  try {
    dispatch({
      type: LOGIN_OTP_REQUEST,
    });
    const { data } = await Axios.post(
      `${Prefix.api}/notification/send_otp/?from=website`,
      otpDetails
    );
    dispatch({
      type: LOGIN_OTP_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: LOGIN_OTP_ERROR,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const otpVerification = (otpVerifyDetails) => async (dispatch) => {
  try {
    dispatch({
      type: OTP_VERIFICATION_REQUEST,
    });
    const { data } = await Axios.post(
      `${Prefix.api}/auth/users/otplogin/`,
      otpVerifyDetails
    );
    dispatch({
      type: OTP_VERIFICATION_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: OTP_VERIFICATION_ERROR,
      payload: error.response.data.errors
        ? error.response.data.errors.error[0]
        : error.message,
    });
  }
};

export const registerUser = (userDetails) => async (dispatch) => {
  try {
    dispatch({
      type: REGISTER_USER_REQUEST,
    });
    const { data } = await Axios.post(
      `${Prefix.api}/auth/users/register/`,
      userDetails
    );
    dispatch({
      type: REGISTER_USER_SUCCESS,
      payload: data,
    });
  } catch (error) {
    // if (error.response.data) {
    //   dispatch({
    //     type: REGISTER_USER_VALIDATION,
    //     payload: error.response.data,
    //   });
    // }

    dispatch({
      type: REGISTER_USER_FAIL,

      payload: error.response.data,
    });
  }
};

export const getCity = () => async (dispatch) => {
  try {
    dispatch({
      type: GET_CITY_REQUEST,
    });
    const { data } = await Axios.get(`${Prefix.api}/core/displaycities/`);
    dispatch({
      type: GET_CITY_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: GET_CITY_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const getCityLpPage = () => async (dispatch) => {
  try {
    dispatch({
      type: GET_CITY_MAIN_REQUEST,
    });
    const { data } = await Axios.get(`${Prefix.api}/core/alldisplaycities/`);
    dispatch({
      type: GET_CITY_MAIN_SUCCESS,
      payload: data,
    });
    console.log(data, "here it is");
  } catch (error) {
    dispatch({
      type: GET_CITY_MAIN_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const setCity = (cityObj = "") => async (dispatch) => {
  try {
    dispatch({
      type: SET_CITY_SUCCESS,
      payload: cityObj,
    });
  } catch (error) {
    dispatch({
      type: SET_CITY_FAIL,
      payload: error.message,
    });
  }
};

export const setMainSearch = (mainsearch) => async (dispatch) => {
  try {
    dispatch({
      type: SET_SEARCH_SUCCESS,
      payload: mainsearch,
    });
  } catch (error) {
    dispatch({
      type: SET_SEARCH_FAIL,
      payload: error.message,
    });
  }
};

export const setLogout = (isLogout) => async (dispatch) => {
  try {
    dispatch({
      type: SET_ISLOGOUT_SUCCESS,
      payload: isLogout,
    });
  } catch (error) {
    dispatch({
      type: SET_ISLOGOUT_FAIL,
      payload: error.message,
    });
  }
};

export const customerBookingDetails = (token) => async (dispatch) => {
  try {
    dispatch({
      type: GET_CUSTOMER_BOOKING_REQUEST,
    });
    const config = {
      headers: {
        Authorization: `Token ${token}`,
      },
    };
    const { data } = await Axios.get(
      `${Prefix.api}/booking/customer_booking/`,
      config
    );
    dispatch({
      type: GET_CUSTOMER_BOOKING_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: GET_CUSTOMER_BOOKING_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const Smsconfirmbooking = (id) => async (dispatch) => {
  try {
    dispatch({
      type: SMS_VERIFICATION_CONFIRM,
    });
    const { data } = await Axios.get(
      `${Prefix.api}/communication/bookingverification/${id}/confirmed/`
    );
    dispatch({
      type: SMS_VERIFICATION_CONFIRM_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: SMS_VERIFICATION_CONFIRM_ERROR,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const Smscancelledbooking = (id) => async (dispatch) => {
  try {
    dispatch({
      type: SMS_VERIFICATION_CANCEL,
    });
    const { data } = await Axios.get(
      `${Prefix.api}/communication/bookingverification/${id}/cancelled/`
    );
    dispatch({
      type: SMS_VERIFICATION_CANCEL_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: SMS_VERIFICATION_CANCEL_ERROR,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const SmsViewbooking = (id) => async (dispatch) => {
  try {
    dispatch({
      type: VIEW_BOOKING,
    });
    const { data } = await Axios.get(
      `${Prefix.api}/communication/bookingverification/${id}/view/`
    );
    dispatch({
      type: VIEW_BOOKING_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: VIEW_BOOKING_ERROR,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const UnsubscribeUser = (id) => async (dispatch) => {
  try {
    dispatch({
      type: UNSUBSCRIEBE_REQUEST,
    });
    const { data } = await Axios.put(`${Prefix.api}/blog/news_letter/${id}/`);
    dispatch({
      type: UNSUBSCRIEBE_REQUEST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: UNSUBSCRIEBE_REQUEST_ERROR,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};
export const downloadReport = (pk, token) => async (dispatch) => {
  try {
    dispatch({
      type: GET_REPORT_REQUEST,
    });
    const config = {
      headers: {
        Authorization: `Token ${token}`,
      },
    };
    const { data } = await Axios.get(
      `${Prefix.api}/booking/report_status/${pk}/`,
      config
    );
    dispatch({
      type: GET_REPORT_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: GET_REPORT_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const testimonials = () => async (dispatch) => {
  try {
    dispatch({
      type: GET_TESTIMONIALS_REQUEST,
    });
    const { data } = await Axios.get(`${Prefix.api}/blog/testimonials/`);
    // console.log(data)
    dispatch({
      type: GET_TESTIMONIALS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: GET_TESTIMONIALS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const Imaginetestimonials = () => async (dispatch) => {
  try {
    dispatch({
      type: GET_IMAGINE_TESTIMONIALS_REQUEST,
    });
    const { data } = await Axios.get(
      `${Prefix.api}/blog/testimonials/?org_type=imaging`
    );
    // console.log(data)
    dispatch({
      type: GET_IMAGINE_TESTIMONIALS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: GET_IMAGINE_TESTIMONIALS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const blogsAction = () => async (dispatch) => {
  try {
    dispatch({
      type: GET_BLOGS_REQUEST,
    });
    const { data } = await Axios.get(`${Prefix.api}/blog/blog_card/`);
    dispatch({
      type: GET_BLOGS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: GET_BLOGS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

//GETTING JOB PROFILE DETAILS
export const getJobData = () => async (dispatch) => {
  try {
    dispatch({
      type: GET_JOB_REQUEST,
    });
    const { data } = await Axios.get(`${Prefix.api}/core/career/jobprofile/`);
    dispatch({
      type: GET_JOB_REQUEST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: GET_JOB_REQUEST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const careerFormSubmit = (body) => async (dispatch) => {
  try {
    dispatch({
      type: SEND_PROFILE_DATA,
    });
    const { data } = await Axios.post(
      `${Prefix.api}/core/career/create/`,
      body
    );
    dispatch({
      type: SEND_PROFILE_DATA_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: SEND_PROFILE_DATA_ERROR,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const uploadPrescription = (body, token, org_type) => async (
  dispatch
) => {
  try {
    dispatch({
      type: UPLOAD_PRESCRIPTION,
    });
    console.log(token);
    const config = {
      headers: {
        Authorization: `Token ${token}`,
        "Content-Type": "multipart/form-data",
      },
    };
    const { data } = await Axios.post(
      `${Prefix.api}/booking/prescription_upload/?lead=true&${org_type ? `org_type=${org_type}` : ""
      }`,
      body,
      config
    );
    dispatch({
      type: UPLOAD_PRESCRIPTION_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: UPLOAD_PRESCRIPTION_ERROR,
      payload: error.response.data.errors,
    });
  }
};

export const uploadLp = (body) => async (dispatch) => {
  try {
    dispatch({
      type: UPLOAD_PRESCRIPTION_LP,
    });
    // console.log(token);
    const config = {
      headers: {
        // Authorization: `Token ${token}`,
        "Content-Type": "multipart/form-data",
      },
    };
    const { data } = await Axios.post(
      `${Prefix.api}/booking/prescription_upload/?lead=true`,
      body,
      config
    );
    dispatch({
      type: UPLOAD_PRESCRIPTION_SUCCESS_LP,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: UPLOAD_PRESCRIPTION_ERROR_LP,
      payload: error.response.data.errors,
    });
  }
};

export const EditForm = (token, body, phonenumber, successCb) => async (
  dispatch
) => {
  try {
    dispatch({
      type: EDIT_PROFILE_REQUEST,
    });
    const config = {
      headers: {
        Authorization: `Token ${token}`,
      },
    };
    const { data } = await Axios.put(
      `${Prefix.api}/auth/users/${phonenumber}/`,
      body,
      config
    );

    console.log(data, "jskdj skjd lksldk lskdlsdk");
    dispatch({
      type: EDIT_PROFILE_SUCCESS,
      payload: data,
    });
    successCb && successCb();
  } catch (error) {
    dispatch({
      type: EDIT_PROFILE_ERROR,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

//NEWSLETTER API

export const newsLetterAction = (body) => async (dispatch) => {
  try {
    dispatch({
      type: NEWS_LETTER_REQUEST,
    });
    const { data } = await Axios.post(
      `${Prefix.api}/blog/news_letter/create/`,
      body
    );

    dispatch({
      type: NEWS_LETTER_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: NEWS_LETTER_ERRROR,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// center lab action

export const centerAction = (city, labname) => async (dispatch) => {
  try {
    dispatch({
      type: GET_CENTER_REQUEST,
    });

    const { data } = await Axios.get(
      `${Prefix.api}/panel/lab_web/?city=${city}&name=${labname}`
    );
    dispatch({
      type: GET_CENTER_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: GET_CENTER_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// center collection action

export const centerCollectionAction = (cityname, name) => async (dispatch) => {
  try {
    dispatch({
      type: GET_CENTER_COLLECTION_REQUEST,
    });

    const { data } = await Axios.get(
      `${Prefix.api}/center/data/?cityname=${cityname}&name=${name}`
    );
    dispatch({
      type: GET_CENTER_COLLECTION_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: GET_CENTER_COLLECTION_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const paginationAction = (page) => async (dispatch) => {
  try {
    dispatch({
      type: PAGINATION_REQUEST,
    });

    const { data } = await Axios.get(
      `${Prefix.api}/center/data/?cityname=&page=${page}`
    );
    dispatch({
      type: PAGINATION_REQUEST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: PAGINATION_COLLECTION_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// center lab action

export const labPagination = (page) => async (dispatch) => {
  try {
    dispatch({
      type: LAB_PAGINATION_REQUEST,
    });

    const { data } = await Axios.get(
      `${Prefix.api}/panel/lab_web/?city=&page=${page}`
    );
    dispatch({
      type: LAB_PAGINATION_REQUEST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: LAB_PAGINATION_COLLECTION_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// career pagination action

export const careerPagination = (page) => async (dispatch) => {
  try {
    dispatch({
      type: CAREER_PAGINATION_REQUEST,
    });

    const { data } = await Axios.get(
      `${Prefix.api}/core/career/jobprofile/?page=${page}`
    );
    dispatch({
      type: CAREER_PAGINATION_REQUEST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: CAREER_PAGINATION_COLLECTION_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

//GET FAMILY AND FRIENDS DATA

export const familyFriendAction = (token) => async (dispatch) => {
  try {
    dispatch({
      type: GET_FAMILY_FRIENDS_DATA_REQUEST,
    });
    const config = {
      headers: {
        Authorization: `Token ${token}`,
      },
    };

    const { data } = await Axios.get(
      `${Prefix.api}/booking/additional_booking/1505/`,
      // `${Prefix.api}/booking/additional_booking/1505/${pk}`,
      config
    );
    dispatch({
      type: GET_FAMILY_FRIENDS_DATA_REQUEST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: GET_FAMILY_FRIENDS_DATA_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

//POST FAMILY AND FRIENDS DATA

export const familyFriendPostAction = (token, body, successCb) => async (
  dispatch
) => {
  try {
    dispatch({
      type: POST_FAMILY_FRIENDS_DATA_REQUEST,
    });

    const config = {
      headers: {
        Authorization: `Token ${token}`,
      },
    };

    const { data } = await Axios.post(
      `${Prefix.api}/booking/additional_booking/1505/`,
      body,
      config
    );
    dispatch({
      type: POST_FAMILY_FRIENDS_DATA_REQUEST_SUCCESS,
      payload: data,
    });
    successCb && successCb();
  } catch (error) {
    dispatch({
      type: POST_FAMILY_FRIENDS_DATA_FAIL,
      payload:
        error.message && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const paymentUpadte = (token, body) => async (dispatch) => {
  try {
    dispatch({
      type: POST_PAYMENT_INFO,
    });

    const config = {
      headers: {
        Authorization: `Token ${token}`,
      },
    };

    const { data } = await Axios.post(
      `${Prefix.api}/payment/order_payment/`,
      body,
      config
    );

    dispatch({
      type: POST_PAYMENT_INFO_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: POST_PAYMENT_INFO_FAIL,
      payload:
        error.message && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// Address actions

export const getAllAddress = (token) => async (dispatch) => {
  try {
    dispatch({
      type: GET_ALL_ADDRESS_REQUEST,
    });
    const config = {
      headers: {
        Authorization: `Token ${token}`,
      },
    };

    const { data } = await Axios.get(`${Prefix.api}/auth/address/`, config);
    dispatch({
      type: GET_ALL_ADDRESS_REQUEST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: GET_ALL_ADDRESS_REQUEST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const addressFormSubmit = (token, body) => async (dispatch) => {
  try {
    dispatch({
      type: CREATE_ADDRESS_REQUEST,
    });
    // console.log( "params token" ,token)
    const config = {
      headers: {
        Authorization: `Token ${token}`,
      },
    };

    const { data } = Axios.post(`${Prefix.api}/auth/address/`, body, config);
    dispatch({
      type: CREATE_ADDRESS_REQUEST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: CREATE_ADDRESS_REQUEST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const editAddressForm = (token, body, id, successFun) => async (
  dispatch
) => {
  try {
    dispatch({
      type: EDIT_ADDRESS_REQUEST,
    });

    const config = {
      headers: {
        Authorization: `Token ${token}`,
      },
    };

    const { data } = Axios.put(
      `${Prefix.api}/auth/address/${id}/`,
      body,
      config
    );

    dispatch({
      type: EDIT_ADDRESS_REQUEST_SUCCESS,
      payload: data,
    });
    successFun && successFun();
  } catch (error) {
    dispatch({
      type: EDIT_ADDRESS_REQUEST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

//GET REPORT STATUS
export const getReportStatus = (pk, token, isAdditional) => async (
  dispatch
) => {
  try {
    dispatch({
      type: GET_REPORT_REQUEST_USER,
    });
    const config = {
      headers: {
        Authorization: `Token ${token}`,
      },
    };
    if (isAdditional) {
      const { data } = await Axios.get(
        `${Prefix.api}/booking/report_status/${pk}/?additional_id=true`,
        config
      );
      // console.log(data, "Here is action data addiioal");
      dispatch({
        type: GET_REPORT_SUCCESS_USER,
        payload: data,
      });
    } else {
      const { data } = await Axios.get(
        `${Prefix.api}/booking/report_status/${pk}/`,
        config
      );
      dispatch({
        type: GET_REPORT_SUCCESS_USER,
        payload: data,
      });
      // console.log(data, "give up");
    }
    // console.log(data, "Here is action data");
    // data
    //   .then((res) => {
    //     console.log("data in response", res);
    // })
    // .catch((error) => console.log(error));
  } catch (error) {
    dispatch({
      type: GET_REPORT_ERROR_USER,
      payload: error,
    });
  }
};

export const getCartDetails = (token, cityname, center) => async (dispatch) => {
  try {
    dispatch({
      type: GET_CART_REQUEST,
    });

    const config = {
      headers: {
        Authorization: `Token ${token}`,
      },
    };
    if (cityname && center) {
      const { data } = await Axios.get(
        `${Prefix.api}/cart/?city=${cityname}&center_address=${center ?? ""}`,
        config
      );
      dispatch({
        type: GET_CART_SUCCESS,
        payload: data,
      });
    } else if (cityname && !center) {
      const { data } = await Axios.get(
        `${Prefix.api}/cart/?city=${cityname}`,
        config
      );
      dispatch({
        type: GET_CART_SUCCESS,
        payload: data,
      });
    } else if (!cityname && !center) {
      const { data } = await Axios.get(`${Prefix.api}/cart/`, config);
      dispatch({
        type: GET_CART_SUCCESS,
        payload: data,
      });
    } else {
      const { data } = await Axios.get(
        `${Prefix.api}/cart/?city=${cityname}&center_address=${center ?? ""}`,
        config
      );
      dispatch({
        type: GET_CART_SUCCESS,
        payload: data,
      });
    }
  } catch (error) {
    if (error?.response?.request?.status == 403) {
      // localStorage.removeItem("user");
    }
    dispatch({
      type: GET_CART_ERROR,
      payload: error,
    });
  }
};

//ADD TO CART

export const AddtoCart = (body, token, successCb) => async (dispatch) => {
  try {
    dispatch({
      type: POST_CART_REQUEST,
    });
    const config = {
      headers: {
        Authorization: `Token ${token}`,
      },
    };

    const { data } = await Axios.post(`${Prefix.api}/cart/`, body, config);
    dispatch({
      type: POST_CART_SUCCESS,
      payload: data,
    });

    //  console.log("from csrd" , successCb)
    successCb && successCb(data);
  } catch (error) {
    console.log(error);
  }
};

//DELETE CART ACTION

export const deleteCart = (token, productId, successCb) => async (dispatch) => {
  console.log("Deleted item from 1");
  try {
    dispatch({
      type: DELETE_CART_REQUEST,
    });

    const config = {
      headers: {
        Authorization: `Token ${token}`,
      },
    };

    const { data } = await Axios.delete(
      `${Prefix.api}/cart/${productId}/`,
      config
    );

    dispatch({
      type: DELETE_CART_SUCCESS,
      payload: data,
    });

    successCb && successCb();
  } catch (error) {
    dispatch({
      type: DELETE_CART_ERROR,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

//DELETE MULTIPLE ITEM FROM CART ACTION

export const deleteMulitItemsCart = (token, productId, successCb) => async (
  dispatch
) => {
  try {
    dispatch({
      type: DELETE_MULTI_ITEMS_CART_REQUEST,
    });

    const config = {
      headers: {
        Authorization: `Token ${token}`,
      },
    };

    const { data } = await Axios.get(
      `${Prefix.api}/cart/delete-multiple/?multiple_ids=${productId}`,
      config
    );

    dispatch({
      type: DELETE_MULTI_ITEMS_CART_SUCCESS,
      payload: data,
    });

    successCb && successCb();
  } catch (error) {
    dispatch({
      type: DELETE_MULTI_ITEMS_CART_ERROR,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

//getArea pin code
export const getAreaPincode = (pincode, city) => async (dispatch) => {
  try {
    dispatch({
      type: GET_PINCODE_REQUEST,
    });
    console.log("city", city);
    const { data } = await Axios.get(
      `${Prefix.api}/phlebo/pincode/?code=${pincode}&city_name=${city}`
    );

    dispatch({
      type: GET_PINCODE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: GET_PINCODE_ERROR,
      payload: error?.response?.data?.detail,
    });
  }
};

//POST NEW ADDRESS

export const postNewAddress = (token, body, successAdd) => async (dispatch) => {
  try {
    dispatch({
      type: POST_ADDRESS_REQUEST,
    });

    const config = {
      headers: {
        Authorization: `Token ${token}`,
      },
    };
    const { data } = await Axios.post(
      `${Prefix.api}/auth/address/`,
      body,
      config
    );
    dispatch({
      type: POST_ADDRESS_REQUEST_SUCCESS,
      payload: data,
    });
    successAdd && successAdd();
  } catch (error) {
    dispatch({
      type: POST_ADDRESS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

//delete address

export const deleteAddress = (token, id, successFun) => async (dispatch) => {
  try {
    dispatch({
      type: DELETE_ADDREESS_REQUEST,
    });

    const config = {
      headers: {
        Authorization: `Token ${token}`,
      },
    };

    const body = {
      is_active: false,
    };

    const { data } = await Axios.put(
      `${Prefix.api}/auth/address/${id}/`,
      body,
      config
    );

    dispatch({
      type: DELETE_ADDRESS_SUCCESS,
      payload: data,
    });

    successFun && successFun();
  } catch (error) {
    dispatch({
      type: DELETE_ADDREESS_FAIL,
      error:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const CreateBooking = (body, token) => (dispatch) => {
  try {
    dispatch({
      type: CREATE_BOOKING_REQUEST,
    });

    const config = {
      headers: {
        Authorization: `Token ${token}`,
      },
    };
    const data = Axios.post(
      `${Prefix.api}/booking/customer/create/`,
      body,
      config
    );

    data
      .then((res) => {
        console.log("data", res);
        localStorage.setItem("bookingID", res?.data?.pk);
        const { data } = res;
        dispatch({
          type: CREATE_BOOKING_SUCCESS,
          payload: data,
        });

        JSON.stringify(
          localStorage.setItem("customerDetails", JSON.stringify(data))
        );

        dispatch({
          type: EMPTY_REDUCER,
          payload: "",
        });
      })
      .catch((err) => {
        dispatch({
          type: CREATE_BOOKING_ERROR,
          payload: err,
        });
        dispatch({
          type: EMPTY_REDUCER,
          payload: "",
        });
      });
  } catch (error) {
    console.log("error on booking", error);
  }
};

//EMPTY_CART_REQUEST,EMPTY_CART_SUCCESS,EMPTY_CART_FAIL

export const EmptyCart = (token, successCd) => async (dispatch) => {
  try {
    dispatch({
      type: EMPTY_CART_REQUEST,
    });

    const config = {
      headers: {
        Authorization: `Token ${token}`,
      },
    };
    const { data } = await Axios.delete(`${Prefix.api}/cart/`, config);
    dispatch({
      type: EMPTY_CART_SUCCESS,
      payload: data,
    });
    successCd && successCd();
  } catch (error) {
    dispatch({
      type: EMPTY_CART_FAIL,
      payload: error,
    });
  }
};

export const SeletSlot = (slot, date) => (dispatch) => {
  try {
    dispatch({
      type: SELECT_SLOT,
      payload: { slot, date },
    });

    console.log("slot date and time", slot + " " + date);
  } catch (error) {
    console.log(error);
  }
};

export const getCouponCode = (token, code = "") => async (dispatch) => {
  try {
    dispatch({
      type: GET_COUPON_CODE_REQUEST,
    });

    const config = {
      headers: {
        Authorization: `Token ${token}`,
      },
    };
    const { data } = await Axios.get(
      `${Prefix.api}/coupon/customer-data/?code=${code}`,
      config
    );

    dispatch({
      type: GET_COUPON_CODE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: GET_COUPON_CODE_ERROR,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const AddFeedback = (body) => async (dispatch) => {
  try {
    dispatch({
      type: ADD_FEEDBACK_REQUEST,
    });

    const { data } = await Axios.post(
      `${Prefix.api}/blog/feedback/create/`,
      body
    );

    dispatch({
      type: ADD_FEEDBACK_SUCCESS,
      payload: data,
    });
  } catch (error) {
    console.log(error);
  }
};

export const setImgCenterAddress = (CenterAddress) => async (dispatch) => {
  console.log("set Addese here", CenterAddress);
  try {
    dispatch({
      type: SET_CENTERADDRESS_SUCCESS,
      payload: CenterAddress,
    });
  } catch (error) {
    dispatch({
      type: SET_CENTERADDRESS_FAIL,
      payload: error.message,
    });
  }
};

export const getImgTimeSlot = (packages = "", center_address = "") => async (
  dispatch
) => {
  console.log(packages, center_address, ">");
  try {
    dispatch({
      type: GET_IMG_TIME_SLOT_REQUEST,
    });
    const { data } = await Axios.get(
      `${Prefix.api}/phlebo/imagingtimeslots/?packages=${packages}&center_address=${center_address}`
    );

    dispatch({
      type: GET_IMG_TIME_SLOT_SUCCESS,
      payload: data.results,
    });
  } catch (error) {
    dispatch({
      type: GET_IMG_TIME_SLOT_ERROR,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const getSingleImagingPackage = (packageName, city, center) => async (
  dispatch
) => {
  try {
    dispatch({
      type: GET_DETAILS_IMG_PACKAGES_REQUEST,
    });
    if (packageName && city && center) {
      var { data } = await Axios.get(
        `${Prefix.api}/package/data_web/imaging/?slug=${packageName}&center_address=${center}&city=${city}`
      );

      dispatch({
        type: GET_DETAILS_IMG_PACKAGES_SUCCESS,
        payload: data.results[0],
      });
    } else if (packageName && center) {
      var { data } = await Axios.get(
        `${Prefix.api}/package/data_web/imaging/?slug=${packageName}&center_address=${center}`
      );

      dispatch({
        type: GET_DETAILS_IMG_PACKAGES_SUCCESS,
        payload: data.results[0],
      });
    } else if (packageName) {
      var { data } = await Axios.get(
        `${Prefix.api}/package/data_web/imaging/?slug=${packageName}`
      );

      dispatch({
        type: GET_DETAILS_IMG_PACKAGES_SUCCESS,
        payload: data.results[0],
      });
    } else {
      var { data } = await Axios.get(
        `${Prefix.api}/package/data_web/imaging/?slug=${packageName}&center_address=${center}&city=${city}`
      );

      dispatch({
        type: GET_DETAILS_IMG_PACKAGES_SUCCESS,
        payload: data.results[0],
      });
    }
  } catch (error) {
    dispatch({
      type: GET_DETAILS_IMG_PACKAGES_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const getMapMyIndiaAccessToken = (token) => async (dispatch) => {
  try {
    dispatch({
      type: GET_MAP_MY_INDIA_ACCESS_TOKEN,
    });
    const config = {
      headers: {
        Authorization: `Token ${token}`,
      },
    };
    var { data } = await Axios.get(
      `${Prefix.api}/panel/mapmyindia-auth-token/`,
      config
    );
    // console.log(data.accesstoken,"sdsd")
    dispatch({
      type: GET_MAP_MY_INDIA_ACCESS_TOKEN_SUCCESS,
      payload: data.accesstoken,
    });
  } catch (error) {
    dispatch({
      type: GET_MAP_MY_INDIA_ACCESS_TOKEN_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const getCurrentLocation = () => async (dispatch) => {
  try {
    dispatch({
      type: GET_USER_CURRENT_LOCATION_REQUEST,
    });

    var { data } = await Axios.get(
      `https://geolocation-db.com/json/d802faa0-10bd-11ec-b2fe-47a0872c6708`
    );

    dispatch({
      type: GET_USER_CURRENT_LOCATION_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: GET_USER_CURRENT_LOCATION_FAIL,
      payload: error,
    });
  }
};

export const getEvents = () => async (dispatch) => {
  try {
    dispatch({
      type: GET_EVENTS,
    });

    const { data } = await Axios.get(`${Prefix.api}/lead/corp_event/`);

    dispatch({
      type: GET_EVENTS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: GET_EVENTS_FAILS,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const registerEvent = (body) => async (dispatch) => {
  try {
    dispatch({
      type: POST_EVENT_REGISTRATION,
    });

    const { data } = await Axios.post(
      `${Prefix.api}/lead/even_registration/`,
      body
    );

    dispatch({
      type: POST_EVENT_REGISTRATION_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: POST_EVENT_REGISTRATION_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const getState = () => async (dispatch) => {
  try {
    dispatch({
      type: GET_STATE_REQUEST,
    });

    const { data } = await Axios.get(`${Prefix.api}/core/state/`);

    dispatch({
      type: GET_STATE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: GET_STATE_ERROR,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const postFrenchiseInfo = (body) => async (dispatch) => {
  try {
    dispatch({
      type: POST_FEANCHISE_FORM_REQUEST,
    });

    const { data } = await Axios.post(
      `${Prefix.api}/lead/franchise_lead/`,
      body
    );
    dispatch({
      type: POST_FEANCHISE_FORM_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: POST_FEANCHISE_FORM_ERROR,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

///
export const VerfiyUser = (body) => async (dispatch) => {
  try {
    dispatch({
      type: VERFIY_USER_REQUEST,
    });


    const { data } = await Axios.post(
      `${Prefix.api}/payment/order_payment/`, body
    );

    dispatch({
      type: VERFIY_USER_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: VERFIY_USER_FAIL,
      error: error,
    });
    console.log("errr", error.response);
  }
};

export const prescriptionDataAction = (token) => async (dispatch) => {
  try {
    dispatch({
      type: GET_PRESCRIPTION_DATA_REQUEST,
    });
    const config = {
      headers: {
        Authorization: `Token ${token}`,
      },
    };

    const { data } = await Axios.get(
      `${Prefix.api}/booking/prescription_upload/`,
      config
    );

    dispatch({
      type: GET_PRESCRIPTION_DATA_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: GET_PRESCRIPTION_DATA_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const getFamilyCartData = (token) => async (dispatch) => {
  try {
    dispatch({
      type: GET_FAMILY_CART_DATA_REQUEST
    })

    const config = {
      headers: {
        Authorization: `Token ${token}`,
      },
    };

    const { data } = await Axios.get(
      `${Prefix.api}/cart/family-cart-list/`,
      config
    );

    dispatch({
      type: GET_FAMILY_CART_DATA_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: GET_FAMILY_CART_DATA_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
}